import React from 'react';
import PropTypes from 'prop-types';

import HomepageEmbed from 'components/Homepage/HomepageEmbed';
import HomepageVideo from 'components/Homepage/HomepageVideo';
import RichImage from 'components/RichImage';

function HomepageTileAsset({ asset, className, isAnimatedSVG, isHovering, isRecolorableSVG, onLoad, scrollPercentage, size, title, videoOptions: { autoplay, isPlaying, onPause, onPlay } }) {
	function isSVG() {
		return asset.type === 'image' && /\.svg$/.test(asset.asset.image);
	}

	return (<>
		{ asset.type === 'image' && !isSVG() &&
			<img
				alt={ title }
				className={ className }
				onLoad={ onLoad }
				src={ asset.asset.image }
			/>
		}
		{ isSVG() &&
			<RichImage
				alt={ title }
				animateOnScrollIntoViewPercentage={ scrollPercentage }
				className={ className }
				height={ parseFloat(asset.height) }
				isAnimatedSVG={ isAnimatedSVG }
				isHovering={ isHovering }
				isRecolorableSVG={ isRecolorableSVG }
				onLoad={ onLoad }
				src={ asset.asset.image }
				width={ parseFloat(asset.width) }
			/>
		}
		{ asset.type === 'embed' &&
			<HomepageEmbed
				asset={ asset }
				autoplay={ autoplay }
				className={ className }
				isPlaying={ isPlaying }
				onLoad={ onLoad }
				onPause={ onPause }
				onPlay={ onPlay }
				size={ size }
				title={ title }
			/>
		}
		{ asset && asset.type === 'video' &&
			<HomepageVideo
				asset={ asset }
				autoplay={ autoplay }
				className={ className }
				isPlaying={ isPlaying }
				onLoad={ onLoad }
				onPause={ onPause }
				onPlay={ onPlay }
			/>
		}
		</>);
}

HomepageTileAsset.propTypes = {
	asset: PropTypes.object.isRequired,
	className: PropTypes.string,
	isAnimatedSVG: PropTypes.bool,
	isHovering: PropTypes.bool,
	isRecolorableSVG: PropTypes.bool,
	onLoad: PropTypes.func.isRequired,
	scrollPercentage: PropTypes.number,
	size: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	videoOptions: PropTypes.object
};

HomepageTileAsset.defaultProps = {
	className: null,
	isAnimatedSVG: false,
	isHovering: false,
	isRecolorableSVG: false,
	scrollPercentage: null,
	videoOptions: null
};

export default HomepageTileAsset;
